import { defineMessages } from 'utils/intl';

export default defineMessages({
  configure: 'Konfiguruj',
  model: 'Model',
  price: 'Cena od',
});
